import {authStore} from './auth.store';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {select} from '@ngneat/elf';

@Injectable({providedIn: 'root'})
export class AuthQuery {
  public token$: Observable<string>;
  public refreshToken$: Observable<string>;

  constructor() {
    this.token$ = authStore.pipe(select(state => state.token));
    this.refreshToken$ = authStore.pipe(select(state => state.refreshToken));
  }
}
